import { usePrintTypeOnChangeCallbacks } from './hooks/usePrintTypeOnChangeCallbacks'
import { getIcon } from './utils/getIcon'
import { printTypes } from '@/features/print/constants'
import { usePrintTypesField } from '@/features/settings/components/PrinterConfiguration/form'
import ToggleItem from '@/features/settings/components/forms/ToggleItem'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'

const PrintTypeToggles: FC = () => {
    const { t } = useTranslation()

    const [fieldValue, fieldOnChange] = usePrintTypesField()

    const onChangeCallbacks = usePrintTypeOnChangeCallbacks(printTypes, fieldValue, fieldOnChange)

    return (
        <View style={styles.container}>
            <View style={styles.subheader}>
                <Typography.Heading variant="h3">
                    {t('settings.printers.printerConfiguration.field.printTypes.label')}
                </Typography.Heading>
            </View>
            {printTypes.map((printType) => (
                <ToggleItem
                    key={printType}
                    label={t(`printTypes.${printType}`, printType)}
                    LabelIcon={getIcon(printType)}
                    checked={fieldValue.includes(printType)}
                    onChange={onChangeCallbacks[printType]}
                />
            ))}
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        width: '100%',
    },
    subheader: {
        paddingBottom: 8,
    },
})

export default PrintTypeToggles
